module.exports = __webpack_public_path__ + "static/fipcmintorgmain-ffa2695f54bcef0bce75d044d693eb33.jpeg";